import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpdateBlobStorageInput, UpdateBlobStoragePayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_BLOB_STORAGE_ACTIVE = gql`
    mutation updateBlobStorageActive($input: UpdateBlobStorageInput!){
        updateFileVersionIsActive(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpdateBlobStorageVersion = async (
    client: ApolloClient<NormalizedCacheObject>,
    blobStorageId: string
): Promise<UpdateBlobStoragePayload | undefined> => {
    const { data, errors } = await client.mutate<{ updateFileVersionIsActive: UpdateBlobStoragePayload }>({
        variables: {
            input: {
                blobStorageId
            }
        },
        mutation: MUTATION_UPDATE_BLOB_STORAGE_ACTIVE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the blob storage version save.');
    }
    if (data && data.updateFileVersionIsActive) {
        return data.updateFileVersionIsActive;
    }
    return undefined;
};